var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V3.99998H22L18 0Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8V4H18L22 8Z",
    fill: "#CBD5E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#10B981"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51562 18H5.61719L6.94922 15.9258H6.98438L8.31641 18H9.48047L7.625 15.1875V15.1758L9.51172 12.3633H8.37891L7.07422 14.4844H7.03125L5.72266 12.3633H4.53125L6.35547 15.1484V15.1602L4.51562 18ZM10.5547 18H14.1484V17.1523H11.5625V12.3633H10.5547V18ZM17.1914 18.1406C18.543 18.1406 19.3906 17.4531 19.3906 16.3555V16.3516C19.3906 15.5 18.8945 15.0234 17.707 14.7734L17.1016 14.6445C16.3984 14.4961 16.1133 14.2461 16.1133 13.8477V13.8438C16.1133 13.3633 16.5586 13.0703 17.1836 13.0703C17.8281 13.0664 18.2461 13.3789 18.3164 13.8164L18.3242 13.8633H19.2891L19.2852 13.8125C19.2148 12.9062 18.4375 12.2227 17.1875 12.2227C15.9688 12.2227 15.1016 12.9023 15.1016 13.9102V13.9141C15.1016 14.7539 15.6016 15.293 16.7539 15.5352L17.3594 15.6602C18.0859 15.8164 18.3789 16.0625 18.3789 16.4688V16.4727C18.3789 16.957 17.9023 17.293 17.2227 17.293C16.5078 17.293 16.0039 16.9805 15.957 16.5078L15.9531 16.4688H14.9766L14.9805 16.5234C15.0508 17.4961 15.8828 18.1406 17.1914 18.1406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.411860d51fedb5eb765195e8d3491724.svg";
export { ForwardRef as ReactComponent };